import Vue from 'vue'
import axios from "axios"
import newVue from '../main'
import Router from 'vue-router'
import RouterCommon from "./common"
import RouterPersonal from "./modules/personal"
import RouterTeam from "./modules/team"
import api_request_personal from '@/http/modules/personal'
import api_request_common from '@/http/modules/common'
import api_request_team from '@/http/modules/team'
import { setColorByRoot } from '@/common/js/theme'
import { setCookie, getCookie } from '@/common/js/assist'
let pageYOffset = 0;
Vue.use(Router)
var routes = [
	...RouterCommon,
	...RouterPersonal,
	...RouterTeam
];
var router = new Router({
	mode: 'history',
	routes: routes
});

function routerCheck(to, from, next){
	setColorByRoot(JSON.parse(sessionStorage.getItem('base_info')).theme);
	if(JSON.parse(sessionStorage.getItem('base_info')).pc_login_show.includes('11')) {
		localStorage.setItem('personal_user_info', JSON.stringify({
			api_token: getCookie(WX_COOKIE_PREFIX + 'api_token')
		}))
	}
	if(to.meta.needLogin) {
		if(to.meta.ticketType == 'personal') {
			if(localStorage.getItem('personal_user_info') || JSON.parse(sessionStorage.getItem('base_info')).is_nouser_version == 1) {
				next()
			} else {
				if(JSON.parse(sessionStorage.getItem('base_info')).pc_login_show.length == 2) {
					//微信扫码登录&&邮箱验证码登录
				} else {
					if(JSON.parse(sessionStorage.getItem('base_info')).pc_login_show.includes('11')) {
						//微信扫码登录
						setCookie('wx_scan_rurl', window.location.href, 5);
						window.location.href = WX_OAUTH_URL + '/wx_oauth_w'
					} else {
						//邮箱验证码登录
						let timer = setInterval(() => {
							if(newVue.$store) {
								window.clearInterval(timer);
								newVue.$store.commit('show_login', true)
							}
						}, 100)
					}
				}
			}
		} else if(to.meta.ticketType == 'team') {
			//teamuser_type_version(5为无用户版)
			if(JSON.parse(sessionStorage.getItem('base_info')).teamuser_type_version == 5) {
				next();
				return false
			}
			if(localStorage.getItem('team_login_info')) {
				if(localStorage.getItem('team_user_info') && sessionStorage.getItem('new_team_user_info')) {
					next()
				} else {
					api_request_team.teamUserInfo().then(res => {
						localStorage.setItem('team_login_info', JSON.stringify({ ...JSON.parse(localStorage.getItem('team_login_info')),
							...res.data
						}));
						localStorage.setItem('team_user_info', JSON.stringify(res.data));
						sessionStorage.setItem('new_team_user_info', true);
						next()
					})
				}
			} else {
				let timer = setInterval(() => {
					if(newVue.$store) {
						window.clearInterval(timer);
						newVue.$store.commit('show_team_login', true)
					}
				}, 100)
			}
		}
	} else {
		if(localStorage.getItem('team_user_info') && !sessionStorage.getItem('new_team_user_info')) {
			api_request_team.teamUserInfo().then(res => {
				localStorage.setItem('team_login_info', JSON.stringify({ ...JSON.parse(localStorage.getItem('team_login_info')),
					...res.data
				}));
				localStorage.setItem('team_user_info', JSON.stringify(res.data));
				sessionStorage.setItem('new_team_user_info', true);
				next()
			})
		} else {
			next()
		}
	}
}

router.beforeEach((to, from, next) => {
	if(from.meta.keepAlive) {
		pageYOffset = window.pageYOffset;
	}
	if(!sessionStorage.getItem('base_info') || !sessionStorage.getItem('text_tip') || !sessionStorage.getItem('text_yq')) {
		axios.all([api_request_common.baseInfo(), api_request_personal.textTip(), api_request_common.yqText()])
			.then(axios.spread(function(baseInfo, textTip, yqText) {
				setColorByRoot(baseInfo.data.theme);
				sessionStorage.setItem('base_info', JSON.stringify(baseInfo.data));
				sessionStorage.setItem('text_tip', JSON.stringify(textTip.data));
				sessionStorage.setItem('text_yq', JSON.stringify(yqText.data));
				routerCheck(to, from, next)
			}))
	} else {
		routerCheck(to, from, next)
	}
});
router.afterEach((to, from) => {
	if(to.meta.keepAlive) {
		window.scrollTo(0, pageYOffset)
	} else {
		window.scrollTo(0, 0)
	}
	newVue.$store.commit('base_info', JSON.parse(sessionStorage.getItem('base_info')));
	newVue.$store.commit('team_login_info', JSON.parse(localStorage.getItem('team_login_info')) || {});
	newVue.$store.commit('ticket_type', to.meta.ticketType);
	newVue.$store.commit('personal_user_info', JSON.parse(localStorage.getItem('personal_user_info')) || {});
});
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}
export default router


// WEBPACK FOOTER //
// ./src/router/index.js